import React from "react";
import { Box, Typography } from "@mui/material";
import shareSuccess from "@assets/facilityNetwork/share-success.svg";
import shareDanger from "@assets/facilityNetwork/share-danger.svg";
import FacilityNetworkFigmaCard from "./FacilityNetworkFigmaCard";
import FacilityNetworkFigmaIcon from "./FacilityNetworkFigmaIcon";
import { FN } from "./facilityNetworkTheme";
import { PARENT_READ_SCOPE_ITEMS } from "./parentReadAccessScope";

const SHARED_ITEMS = PARENT_READ_SCOPE_ITEMS;

type Props = {
  parentShortName: string;
};

function ShareRow({ title, body, shared }: { title: string; body: string; shared: boolean }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, p: 1, width: "100%" }}>
      <FacilityNetworkFigmaIcon src={shared ? shareSuccess : shareDanger} size={20} />
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontFamily: FN.fontFamily,
            fontSize: 14,
            fontWeight: 600,
            color: FN.figmaNeutral,
            lineHeight: "20px",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontFamily: FN.fontFamily,
            fontSize: 14,
            color: FN.figmaNeutral,
            lineHeight: "20px",
          }}
        >
          {body}
        </Typography>
      </Box>
    </Box>
  );
}

export default function FacilityNetworkSharedDataCard({ parentShortName }: Props) {
  const left = SHARED_ITEMS.filter((_, index) => index < 4);
  const right = SHARED_ITEMS.filter((_, index) => index >= 4);

  return (
    <FacilityNetworkFigmaCard>
      <Typography
        sx={{
          fontFamily: FN.fontFamily,
          fontSize: 16,
          fontWeight: 600,
          color: FN.figmaNeutral,
          lineHeight: "22px",
        }}
      >
        What {parentShortName} can see about you
      </Typography>
      <Typography
        sx={{
          fontFamily: FN.fontFamily,
          fontSize: 12,
          color: FN.figmaAccent,
          letterSpacing: "0.25px",
          lineHeight: "16px",
        }}
      >
        Data shared with your parent as part of this link. Their portfolio view aggregates this
        data across all their children.
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 1,
          pt: 1,
        }}
      >
        <Box>
          {left.map((item) => (
            <ShareRow
              key={item.key}
              title={item.title}
              body={item.body}
              shared={item.shared}
            />
          ))}
        </Box>
        <Box>
          {right.map((item) => (
            <ShareRow
              key={item.key}
              title={item.title}
              body={item.body}
              shared={item.shared}
            />
          ))}
        </Box>
      </Box>
    </FacilityNetworkFigmaCard>
  );
}
